import { mapState, mapActions, mapMutations } from "vuex";
import { Carousel3d, Slide } from "vue-carousel-3d";
import { _message } from "@/helpers/_message"
import i18n from "@/helpers/i18n"
export default {
	components: {
		Carousel3d,
		Slide,
	},
	computed: {
		...mapState({
			dotdangkies: (state) => state.dotdangky.dotdangkies,
			dotdangky: (state) => state.dotdangky.dotdangky,
			thisinh: (state) => state.thisinh.thisinh,
		}),
	},
	data() {
		return {
			soCmnd: "",
			length_CMND: 9,
		};
	},
	methods: {
		...mapActions({
			getDotDangKies: "dotdangky/getDotDangKies",
			getDotDangKyHocBaHT: "dotdangky/getDotDangKyHocBaHT",
			findThiSinhByCMND: "thisinh/findThiSinhByCMND",
			getNguyenVongsByThiSinhIdAndDotId:
				"nguyenvong/getNguyenVongsByThiSinhIdAndDotId",
		}),
		...mapMutations({
			getDotDangKy: "dotdangky/getDotDangKy",
		}),
		async checkTimeout(item) {
			let today = await new Date();
			let ngayBatDau = await new Date(item.ngayBatDau);
			let ngayKetThuc = await new Date(item.ngayKetThuc);
			await [today, ngayBatDau, ngayKetThuc].map((item) =>
				item.setHours(0, 0, 0, 0),
			);
			return today >= ngayBatDau && today <= ngayKetThuc;
		},
		addClassButton(item) {
			let classes = [];
			// item.loaiDot === "HOCBA" ? null : classes.push("disabled inactive");
			let today = new Date();
			let ngayBatDau = new Date(item.ngayBatDau);
			let ngayKetThuc = new Date(item.ngayKetThuc);
			let ngayCongBo = new Date(item.ngayCongBo);
			[today, ngayBatDau, ngayKetThuc, ngayCongBo].map((item) =>
				item.setHours(0, 0, 0, 0),
			);
			switch (true) {
				case today < ngayBatDau:
					classes.push("disabled inactive btn-secondary");
					break;
				case today > ngayKetThuc && today < ngayCongBo:
					classes.push("disabled inactive btn-secondary");
					break;
				case today >= ngayCongBo:
					classes.push("btn-success");
					break;
				default:
					classes.push("btn-primary");
			}
			return classes.join(" ");
		},
		checkDisabled(item) {
			let today = new Date();
			let ngayBatDau = new Date(item.ngayBatDau);
			let ngayKetThuc = new Date(item.ngayKetThuc);
			let ngayCongBo = new Date(item.ngayCongBo);
			[today, ngayBatDau, ngayKetThuc, ngayCongBo].map((item) =>
				item.setHours(0, 0, 0, 0),
			);
			switch (true) {
				case today < ngayBatDau:
					return true;
				case today > ngayKetThuc && today < ngayCongBo:
					return true;
				default:
					return false;
			}
		},
		dangKyBangHocBa(item) {
			let today = new Date();
			let ngayBatDau = new Date(item.ngayBatDau);
			let ngayKetThuc = new Date(item.ngayKetThuc);
			[today, ngayBatDau, ngayKetThuc].map((item) => item.setHours(0, 0, 0, 0));
			switch (true) {
				case today < ngayBatDau:
					_message.messageDangKyFalse(1);
					break;
				case today > ngayKetThuc:
					_message.messageDangKyFalse(2);
					break;
				default:
					// if (item.loaiDot.trim() === "HOCBA")
					this.$router.push({
						name: "dang-ky-hoc-ba",
						params: { dotDangKyId: item.dotDangKyId },
					});
			}
		},
		dieuChinhBangHocBa(item) {
			let today = new Date();
			let ngayBatDau = new Date(item.ngayBatDau);
			let ngayKetThuc = new Date(item.ngayKetThuc);
			[today, ngayBatDau, ngayKetThuc].map((item) => item.setHours(0, 0, 0, 0));
			switch (true) {
				case today < ngayBatDau:
					_message.messageDangKyFalse(1);
					break;
				case today > ngayKetThuc:
					_message.messageDangKyFalse(2);
					break;
				default:
					this.$router.push({
						name: "dieu-chinh-nguyen-vong",
					});
			}
		},

		textButton(item) {
			let today = new Date();
			let ngayBatDau = new Date(item.ngayBatDau);
			let ngayKetThuc = new Date(item.ngayKetThuc);
			let ngayCongBo = new Date(item.ngayCongBo);
			[today, ngayBatDau, ngayKetThuc, ngayCongBo].map((item) =>
				item.setHours(0, 0, 0, 0),
			);
			switch (true) {
				case today < ngayBatDau:
					return this.$t("models.dotDangKy.titleChuaBd");
				case today > ngayKetThuc && today < ngayCongBo:
					return this.$t("models.dotDangKy.titleQuaHan");
				case today >= ngayCongBo:
					return this.$t("models.dotDangKy.traCuu");
				default:
					return this.$t("button.dangKy");
			}
		},

		clickButton(item) {
			let today = new Date();
			let ngayBatDau = new Date(item.ngayBatDau);
			let ngayKetThuc = new Date(item.ngayKetThuc);
			let ngayCongBo = new Date(item.ngayCongBo);
			[today, ngayBatDau, ngayKetThuc, ngayCongBo].map((item) =>
				item.setHours(0, 0, 0, 0),
			);
			switch (true) {
				case today < ngayBatDau:
					_message.messageDangKyFalse(1);

					break;
				case today > ngayKetThuc && today < ngayCongBo:
					_message.messageDangKyFalse(2);
					break;
				case today >= ngayCongBo:
					this.$router.push({
						name: "tra-cuu",
					});
					break;
				default:
					this.selectDangKyOrDieuChinh(item);
					break;
			}
		},

		selectDangKyOrDieuChinh(item) {
			this.getDotDangKy(item);
			this.$modal.show("dangky-thaydoi");
		},
		async timKiem() {
			await this.findThiSinhByCMND(this.soCmnd).then(async (response) => {
				let dotDangKyId = this.dotdangky.dotDangKyId;
				this.$store.commit("thisinh/updateSoCmnd", this.soCmnd);
				if (response.status === 200) {
					await this.getNguyenVongsByThiSinhIdAndDotId({
						thiSinhId: response.data.thiSinhId,
						dotDangKyId: dotDangKyId,
					}).then((response) => {
						var vm = this;
						this.$modal.hide("dangky-thaydoi");
						if (response.status === 200 && response.data.length > 0) {
							// Da dang ky dot hien tai
							_message.confirmEditThiSinh()
								.then(async (result) => {
									if (result.value) {
										vm.$router.push({
											name: "dieu-chinh-nguyen-vong",
										});
									} else {
										await vm.loadNewInfo();
									}
								});
						}
						else {
							this.$router.push({
								name: "dang-ky-hoc-ba",
								params: { dotDangKyId: this.dotdangky.dotDangKyId },
							});
						}
						// else {
						// 	// Da dang ky dot truoc do
						// 	_message.messageDaTrungTuyen()
						// 		.then(async function (result) {
						// 			if (result.value) {
						// 				vm.$router.push({
						// 					name: "dang-ky-hoc-ba",
						// 					params: { dotDangKyId: dotDangKyId },
						// 				});
						// 			} else {
						// 				await vm.loadNewInfo();
						// 			}
						// 		});
						// }
					});
				} else {
					this.$router.push({
						name: "dang-ky-hoc-ba",
						params: { dotDangKyId: this.dotdangky.dotDangKyId },
					});
				}
			});
		},
		async loadNewInfo() {
			await this.$store.commit("nguyenvong/loadNew");
			await this.$store.commit("tohop/loadNew");
			await this.$store.commit("thisinh/loadNew");
			await this.$store.commit("truong/loadNew");
			await this.$store.commit("khaosat/loadNew");
		}
	},

	async beforeCreate() {
		await this.$store.dispatch("dotdangky/getDotDangKies");
	},
	filters: {
		formatDate: function (date) {
			let d = new Date(date),
				month = "" + (d.getMonth() + 1),
				day = "" + d.getDate(),
				year = d.getFullYear();

			if (month.length < 2) month = "0" + month;
			if (day.length < 2) day = "0" + day;

			return [day, month, year].join("/");
		},
		formatGender(gender) {
			return gender.trim() === "Nu" ? i18n.t("models.thiSinh.nu") : i18n.t("models.thiSinh.nams");
		},
	},
	created() {
		// this.getDotDangKyHocBaHT();
	},
	watch: {
		soCmnd(value) {
			if (value.length <= 9) {
				return (this.length_CMND = 9);
			} else {
				return (this.length_CMND = 12);
			}
		},
	},
};
